// referral.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { ApiService } from 'src/app/services/api.service';
import * as vo from 'src/app/core/model/server/vo/_index';

export interface GetReferralsRequest {
  firstName?:   string | null;
  middleName?:  string | null;
  lastName?:    string | null;
  phoneNumber?: string | null;
  status?:      string | null;
  accountType?: string | null;
  tierId?:      number | null;   
  search?:      string | null;
  sortBy?:      { [key: string]: string };
}

export interface GetReferredAccountsRequest {
  referrerNumber: string;
  firstName?:     string | null;
  middleName?:    string | null;
  lastName?:      string | null;
  phoneNumber?:   string | null;
  status?:        string | null;
  accountType?:   string | null;
  tierId?:        number | null; 
  search?:        string | null;
  sortBy?:        { [key: string]: string };
}

@Injectable({
  providedIn: 'root',
})
export class ReferralsService {

  constructor(
    private httpService: RequestsService,
    private apiService: ApiService,
  ) {}

  // ─── Referrals List (main page) ──────────────────────────────────────────────

  getReferralsAccounts(
    page: number,
    size: number,
    request: GetReferralsRequest,
  ): Observable<vo.GetReferralsResponse> {
    return this.apiService.getReferralsAccounts(page, size, request as any);
  }

  // ─── Referred Accounts (modal / view-referal) ────────────────────────────────

  getReferredAccounts(
    page: number,
    size: number,
    request: GetReferredAccountsRequest,
  ): Observable<vo.GetReferralsResponse> {
    return this.apiService.getReferredAccounts(page, size, request as any);
  }

  // ─── Tiers — raw passthrough, components handle mapping ──────────────────────

  getAccountsTiers(): Observable<any> {
    return this.apiService.getAccountsTiers();
  }

  // ─── Export helpers ──────────────────────────────────────────────────────────

  buildQueryParams(params: Record<string, any>): string {
    return Object.entries(params)
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
      .map(([k, v]) =>
        typeof v === 'object'
          ? `${k}=${encodeURIComponent(JSON.stringify(v))}`
          : `${k}=${encodeURIComponent(v)}`,
      )
      .join('&');
  }
}
